import format from 'date-fns/format';

export const TIME_FORMAT = {
  HOUR_24: '24',
  HOUR_12: '12',
};

/** @type {'24' | '12'} */
let activeTimeFormat = TIME_FORMAT.HOUR_24;

export const configureTimeFormat = timeFormat => {
  activeTimeFormat =
    timeFormat === TIME_FORMAT.HOUR_12
      ? TIME_FORMAT.HOUR_12
      : TIME_FORMAT.HOUR_24;
};

export const getTimeFormat = () => activeTimeFormat;

const parseDate = dateInput => {
  if (dateInput == null || dateInput === '') return null;
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  if (Number.isNaN(date.getTime())) return null;
  return date;
};

const formatTime24 = date => format(date, 'HH:mm');
const formatTime12 = date => format(date, 'h:mm a');

export const getTimeFormatPattern = ({ timeFormat } = {}) => {
  const resolved = timeFormat || activeTimeFormat;
  return resolved === TIME_FORMAT.HOUR_12 ? 'h:mm a' : 'HH:mm';
};

export const getDateTimeFormatPattern = (
  datePattern = 'MMM dd, yyyy',
  { timeFormat } = {}
) => `${datePattern} ${getTimeFormatPattern({ timeFormat })}`;

/**
 * Format a time for display. Respects the active time format preference.
 * Override per call via `{ timeFormat: TIME_FORMAT.HOUR_12 }` when needed.
 */
export const formatTime = (dateInput, { timeFormat } = {}) => {
  const date = parseDate(dateInput);
  if (!date) return '';

  const resolved = timeFormat || activeTimeFormat;
  return resolved === TIME_FORMAT.HOUR_12
    ? formatTime12(date)
    : formatTime24(date);
};

/**
 * Format a date-time for display. The time portion follows the active preference.
 */
export const formatDateTime = (
  dateInput,
  { dateFormat = 'MMM dd, yyyy', timeFormat } = {}
) => {
  const date = parseDate(dateInput);
  if (!date) return '';

  return format(date, getDateTimeFormatPattern(dateFormat, { timeFormat }));
};
